(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sockshuttle-v2-header"] && !Shopify.designMode) return;
  try {
    
  const initializeSockShuttleHeader = (root) => {
    if (!root || root.dataset.ssv2Initialized === "true") return
    root.dataset.ssv2Initialized = "true"

    const drawer = root.querySelector("[data-ssv2-drawer]")
    const openButton = root.querySelector("[data-ssv2-drawer-open]")
    const closeButton = root.querySelector("[data-ssv2-drawer-close]")
    const desktopMenus = Array.from(root.querySelectorAll("[data-ssv2-menu]"))
    const hoverQuery = window.matchMedia("(hover: hover) and (min-width: 990px)")
    let returnFocus = null

    const closeDesktopMenus = (except) => {
      desktopMenus.forEach((menu) => {
        if (menu !== except) menu.open = false
      })
    }

    desktopMenus.forEach((menu) => {
      let closeTimer
      const summary = menu.querySelector("summary")

      menu.addEventListener("pointerenter", () => {
        window.clearTimeout(closeTimer)
        if (!hoverQuery.matches) return
        closeDesktopMenus(menu)
        menu.open = true
      })

      menu.addEventListener("pointerleave", () => {
        if (!hoverQuery.matches) return
        closeTimer = window.setTimeout(() => {
          menu.open = false
        }, 350)
      })

      summary.addEventListener("click", (event) => {
        event.preventDefault()

        if (hoverQuery.matches) {
          closeDesktopMenus(menu)
          menu.open = true
          return
        }

        const shouldOpen = !menu.open
        closeDesktopMenus(menu)
        menu.open = shouldOpen
      })

      summary.addEventListener("keydown", (event) => {
        if (event.key !== "ArrowDown") return
        event.preventDefault()
        closeDesktopMenus(menu)
        menu.open = true
        window.setTimeout(() => {
          const firstLink = menu.querySelector(".ssv2-desktop-panel a")
          if (firstLink) firstLink.focus()
        })
      })
    })

    root.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return
      const openMenu = desktopMenus.find((menu) => menu.open)
      if (!openMenu) return
      openMenu.open = false
      const summary = openMenu.querySelector("summary")
      if (summary) summary.focus()
    })

    document.addEventListener("pointerdown", (event) => {
      if (!root.contains(event.target)) closeDesktopMenus()
    })

    if (drawer && openButton && closeButton) {
      const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'

      const restoreDrawerState = () => {
        document.documentElement.classList.remove("ssv2-no-scroll")
        openButton.setAttribute("aria-expanded", "false")
        if (returnFocus instanceof HTMLElement) returnFocus.focus()
      }

      const closeDrawer = () => {
        if (!drawer.hasAttribute("open")) return

        if (typeof drawer.close === "function") {
          drawer.close()
        } else {
          drawer.removeAttribute("open")
          restoreDrawerState()
        }
      }

      const openDrawer = () => {
        if (drawer.hasAttribute("open")) return
        returnFocus = document.activeElement

        if (typeof drawer.showModal === "function") {
          drawer.showModal()
        } else {
          drawer.setAttribute("open", "")
        }

        document.documentElement.classList.add("ssv2-no-scroll")
        openButton.setAttribute("aria-expanded", "true")
        window.setTimeout(() => closeButton.focus())
      }

      openButton.addEventListener("click", openDrawer)
      closeButton.addEventListener("click", closeDrawer)

      drawer.addEventListener("click", (event) => {
        if (event.target === drawer) closeDrawer()
      })

      drawer.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          event.preventDefault()
          closeDrawer()
          return
        }

        if (event.key !== "Tab") return

        const focusable = Array.from(drawer.querySelectorAll(focusableSelector)).filter((element) => {
          return element instanceof HTMLElement && element.offsetParent !== null
        })
        if (focusable.length === 0) return

        const first = focusable[0]
        const last = focusable[focusable.length - 1]

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault()
          last.focus()
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault()
          first.focus()
        }
      })

      drawer.addEventListener("close", restoreDrawerState)
    }
  }

  document.querySelectorAll("[data-ssv2-header]").forEach(initializeSockShuttleHeader)
  document.addEventListener("shopify:section:load", (event) => {
    initializeSockShuttleHeader(event.target.querySelector("[data-ssv2-header]"))
  })

  } catch(e) { console.error(e); }
})();
})();
